import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import usePreventNavigation from '../../../../hooks/usePreventNavigation';
import formatUSD from '../../../../utils/formatUSD';

const AdditionalOfferProducts = ({ history }) => {
  // Prevent user from navigating away from this page
  usePreventNavigation(history, '/v3/additional-offers');

  const {
    shoot,
    shootProducts,
    additionalOfferProducts,
    suggestedProductsLinkToIndex,
  } = useSelector((state) => state.shoot);
  const company = useSelector((state) => state.company);

  const suggestedProductsCategoryProducts =
    shootProducts[suggestedProductsLinkToIndex]?.products || [];

  if (
    additionalOfferProducts?.length > 0 &&
    suggestedProductsCategoryProducts?.length === 0
  ) {
    console.log('Sentry should fire here');
    Sentry.captureMessage(
      `Event ${shoot.id} has a misconfigured suggested products category`,
    );
  }

  // Iterate through the suggestedProducts
  const mappedIds = additionalOfferProducts.reduce((acc, suggestedProduct) => {
    // Find a matching product based on sku
    const matchingProduct = suggestedProductsCategoryProducts.find(
      (shootProduct) => shootProduct.sku === suggestedProduct.sku,
    );

    // If a match is found, map their ids
    if (matchingProduct) {
      acc[suggestedProduct.id] = matchingProduct.id;
    }

    return acc;
  }, {});

  const suggestedProductsCategoryId =
    shootProducts?.[suggestedProductsLinkToIndex]?.id;

  const renderAdditionalOfferProduct = (product) => {
    return (
      <li className="order-product-recs__product" key={`rec-${product.id}`}>
        <div className="order-product-recs__product__info clearfix">
          <div className="order-product-recs__product__name">
            {product.name}
          </div>
          <div className="order-product-recs__product__price">
            {formatUSD(product.price)}
          </div>
        </div>
        <img
          className="order-product-recs__product__image"
          src={product.image_thumbnail}
        />
        <div>{product.description}</div>
      </li>
    );
  };

  const renderProducts = () => {
    const products = additionalOfferProducts.map((product) => {
      return mappedIds[product.id] ? (
        <Link to={`/v3/products-regular/${mappedIds[product.id]}`}>
          {renderAdditionalOfferProduct(product)}
        </Link>
      ) : (
        <>{renderAdditionalOfferProduct(product)}</>
      );
    });

    return <ul className="clearfix">{products}</ul>;
  };

  return (
    <div className="order-product-recs">
      <div className="order-product-recs-container">
        <h3 className="order-product-recs__header">Congratulations!</h3>
        <div className="order-product-recs__subheader">
          {company?.name === 'strawbridge'
            ? 'You have unlocked add-ons. Check out some of our most popular items.'
            : "You've unlocked add-ons and novelties. Check out some of our most popular items."}
        </div>
        {renderProducts()}
        <div
          className="bnl-button--light-blue"
          onClick={() => {
            history.push('/v3/categories/' + suggestedProductsCategoryId);
          }}
        >
          {company?.name === 'strawbridge'
            ? 'More Add-ons'
            : 'More Add-ons, Novelties & Prints'}
        </div>
        <div
          className="bnl-button--dark-gray"
          onClick={() => {
            history.push('/v3/offers');
          }}
        >
          Shopping Home
        </div>
      </div>
    </div>
  );
};

AdditionalOfferProducts.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    block: PropTypes.func.isRequired,
  }).isRequired,
};

export default AdditionalOfferProducts;
